<template>
  <div class="uploadSyetemService">
    <el-form :model="form" label-width="80px">
      <el-form-item
        label="标题"
        prop="name"
        :rules="[
          { required: true, message: '请输入服务标题', trigger: 'blur' },
        ]"
      >
        <el-input v-model="form.name" placeholder="请输入服务标题"></el-input>
      </el-form-item>
      <el-form-item
        label="副标题"
        prop="byName"
        :rules="[
          { required: true, message: '请输入服务副标题', trigger: 'blur' },
        ]"
      >
        <el-input
          v-model="form.byName"
          placeholder="请输入服务副标题"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="服务链接"
        prop="url"
        :rules="[
          { required: true, message: '请输入服务链接', trigger: 'blur' },
        ]"
      >
        <el-input
          v-model="form.url"
          placeholder="请输入服务服务链接"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="排列序号"
        prop="sort"
        :rules="[
          { required: true, message: '请输入排列序号', trigger: 'blur' },
        ]"
      >
        <el-input
          v-model="form.sort"
          placeholder="请输入服务排列序号"
        ></el-input>
      </el-form-item>
      <el-form-item
        label="是否启用"
        :rules="[{ required: true, trigger: 'blur' }]"
      >
        <el-switch active-value="1" inactive-value="0" v-model="form.enable"></el-switch>
      </el-form-item>
      <el-form-item
        label="背景图片"
        prop="icoUrl"
        :rules="[
          { required: true, message: '请选择背景图片', trigger: 'change' },
        ]"
      >
        <el-upload
          class="avatar-uploader"
          action="https://i.hnust.edu.cn/portal-api/v1/service/upload"
          :show-file-list="false"
          accept=".svg, .png, .jpeg, .jpg"
          :before-upload="beforeUpload"
          :http-request="(param) => onRequest(param, form)"
        >
          <template v-if="form.icoUrl">
            <img :src="form.icoUrl" class="avatar" />
          </template>
          <template v-else>
            <i class="el-icon-plus avatar-uploader-icon"></i>
          </template>
        </el-upload>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSubmit">提交</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import request from "@/utils/request";
export default {
  name: "uploadSyetemService",
  computed: {
    ...mapGetters(["request"]),
  },
  data() {
    return {
      form: {
        name: "",
        byName: "",
        url: "",
        icoUrl: "",
        sort: "",
        enable: 0,
      },
    };
  },
  created() {
    if (this.$route.query.id) {
      console.log(this.$route.query.id);
      this.getOne(this.$route.query.id);
    }
  },
  methods: {
    // 有id时根据id获取字段  编辑模式
    async getOne(id) {
      await request({
      //  url: `http://192.168.2.62:20001/portalCenter/rest/portalapp/findOne`,
        url: `https://portal-center-i.hnust.edu.cn/portalCenter/rest/portalapp/findOne`,
        method: "get",
        headerType: "portal",
        params: {
          id: id,
        },
      }).then((res) => {
        console.log(res);
        if (res.code !== 0) {
          this.$message.error("获取错误");
        } else {
          this.form = res.data;
        }
      });
    },

    // 图标上传前文件校验
    beforeUpload(file) {
      // 格式
      const isSupportedFormats =
        file.type === "image/svg+xml" ||
        file.type === "image/png" ||
        file.type === "image/jpeg" ||
        file.type === "image/jpg";
      // 大小
      const isSupportedSize = file.size / 1024 / 1024 < 2;

      if (!isSupportedFormats) {
        this.$message.error("只支持 svg / png / jpg 格式!");
      } else if (!isSupportedSize) {
        this.$message.error("图片大小不能超过 2MB!");
      }

      return isSupportedFormats && isSupportedSize;
    },
    // 图标上传成
    /**
     * 图片上传
     * @param file
     */
    onRequest({ file }) {
      const formData = new FormData();
      formData.append("file", file);
      formData.append("type", "cms");
      this.$request({
        method: "POST",
        headerType: "portal",
        url: `https://i.hnust.edu.cn/portal-api/v1/service/upload`,
        data: formData,
      }).then((res) => {
        const { code, data } = res;
        if (code === 0) {
          this.$set(this.form, "icoUrl", data);
        }
      });
    },
    // 上传
    async onSubmit() {
      console.log(this.form);
      if (!this.form.name) {
        this.$message.error("请输入服务标题");
        return;
      } else if (!this.form.byName) {
        this.$message.error("请输入服务副标题");
        return;
      } else if (!this.form.url) {
        this.$message.error("请输入服务链接");
        return;
      } else if (!this.form.icoUrl) {
        this.$message.error("请上传背景图片");
        return;
      }
      if (this.$route.query.id) {
        await request({
          // url: `http://192.168.2.62:20001/portalCenter/rest/portalapp/update`,
          url: `https://portal-center-i.hnust.edu.cn/portalCenter/rest/portalapp/update`,
          method: "post",
          headerType: "portal",
          data: {
            name: this.form.name,
            byName: this.form.byName,
            url: this.form.url,
            icoUrl: this.form.icoUrl,
            id: this.$route.query.id,
            enable: this.form.enable,
            sort: this.form.sort,
          },
        }).then((res) => {
          console.log(res, "ceshi ");
          if (res.code !== 0) {
            this.$message.error("上传错误");
          } else {
            this.$message.success("上传成功");
            this.$router.push({ name: "systemServiceList" });
          }
        });
      } else {
        await request({
          // url: `http://192.168.2.62:20001/portalCenter/rest/portalapp/add`,
          url: `https://portal-center-i.hnust.edu.cn/portalCenter/rest/portalapp/add`,
          method: "post",
          headerType: "portal",
          data: {
            name: this.form.name,
            byName: this.form.byName,
            url: this.form.url,
            icoUrl: this.form.icoUrl,
            enable: this.form.enable,
            sort: this.form.sort,
          },
        }).then((res) => {
          console.log(res, "ceshi");
          if (res.code !== 0) {
            this.$message.error("上传错误");
          } else {
            this.$message.success("上传成功");
            this.$router.push({ name: "systemServiceList" });
          }
        });
      }
    },
  },
};
</script>

<style scoped lang="scss">
.uploadSyetemService {
  padding: 20px;
  padding-left: 70px;
}
.avatar-uploader /deep/ .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader /deep/ .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 100px;
  height: 100px;
  line-height: 100px;
  text-align: center;
}
.avatar {
  width: 290px;
  height: 84px;
  display: block;
}
/deep/.el-input {
  width: 40%;
}
</style>
